import styled, { css } from 'styled-components';
import { ListVariant } from '../../types/trade';
import Label from '../Label';
import isOmpPlatform from '../../utils/isOmpPlatform';

const isOmp = isOmpPlatform();

const listViewHeader = css`
  grid-column: 1 / span 2;
`;

const gridViewHeader = css`
  grid-column: 1;
  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.GRIDVIEW_DESKTOP_WM}) {
    grid-column: 2;
  }
`;

export const StyledHeader = styled.div`
  ${({ variant }) => variant === ListVariant.LIST && listViewHeader}
  ${({ variant }) => variant === ListVariant.GRID && gridViewHeader}
`;

export const StyledMainHeading = styled.span`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  ${() =>
    isOmp &&
    css`
      font-family: 'Poppins', sans-serif;
      font-size: 30px;
      font-weight: 500;
      color: ${({ theme }) => theme.COLORS.DARK_BLUE};
    `}
`;

export const StyledSubHeading = styled.span`
  ${() =>
    !isOmp &&
    css`
      font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
    `}

  ${() =>
    isOmp &&
    css`
      font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
      margin-left: 12px;
    `}
`;

export const StyledLabel = styled(Label)`
  padding-top: 12px;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};

  ${() =>
    isOmp &&
    css`
      padding-top: 6px;
      font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
    `}
`;
